import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { FCM_CONFIG, FCM_VAPID_KEY } from "../config";
import { requestApi } from "../actions/apiCommon";

initializeApp(FCM_CONFIG);

const messaging = getMessaging();

export const requestForToken = () => {
  return getToken(messaging, { vapidKey: FCM_VAPID_KEY })
    .then((currentToken) => {
      if (currentToken) {
        requestApi.submitFCMToken(currentToken);
        // Perform any other neccessary action with the token
      } else {
        // Show permission request UI
        console.log(
          "No registration token available. Request permission to generate one."
        );
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
    });
};

export const onMessageListener = () => {
  onMessage(messaging, (payload) => {
    const notificationTitle = payload.notification.title;
    const notificationOptions = {
      body: payload.notification.body,
      icon: payload.notification.icon,
    };

    if (!("Notification" in window)) {
      console.log("This browser does not support system notifications.");
    } else if (Notification.permission === "granted") {
      var notification = new Notification(
        notificationTitle,
        notificationOptions
      );
      notification.onclick = function (event) {
        event.preventDefault();
        window.open(payload.data.link || "/", "_blank");
        notification.close();
      };
    }
  });
};
